/* eslint-disable no-self-assign */
import React, { Component, Suspense } from "react";
import { withTranslation,t } from "react-multi-lang";
import { withAlert } from "react-alert";
import "bootstrap";
import "rc-tabs/assets/index.css";
// import Tabs, { TabPane } from "rc-tabs";
// import { AtTabs } from "./../../../controls/custom-node-tabs.styles";
import Service from "./../../general/Service.jsx";
import $ from "jquery";
// import Switch from "react-switch";
import store from "./../../../redux_store/store/index";
//import { onAuditHandler, Servicecalls } from "../../../custom_functions/Functions";
import {
  AuditTrailValidation,
  Servicecalls,
  Silentauditobject,
  Manualauditobject,
  onAuditHandler,
  ControlRights,
  GetutcDate,
  setDateAsuserDefined,
  convertUTCDateToLocalDate,
  killSessionLogout,
  valiadateTenantPackage,
  Onsaveactivewidgetsdata,
  validateCommaSeparate
} from "./../../../custom_functions/Functions.jsx";
import { Modal, ModalBody } from "reactstrap";
import { confirmAlert } from "react-confirm-alert";
import { isMultitenant } from "../../../custom_functions/Constance.jsx";
import KendoCombobox from "../../../controls/KendoCombobox.jsx";
// import Comment from "../../general/Comment";
const Comment = React.lazy(() => import("../../general/Comment"));
const TextBox = React.lazy(() => import("./../../../controls/TextBox.jsx"));
const KendoGridView = React.lazy(() =>
  import("./../../../controls/KendoGridView.jsx")
);
const plantype = valiadateTenantPackage();
// const Service = React.lazy(() => import("./../../general/Service.jsx"));
const SelectBox = React.lazy(() => import("./../../../controls/SelectBox.jsx"));
const Logbook = React.lazy(() => import("./Logbook.jsx"));
const Audit = React.lazy(() => import("./../../../custom_modules/Audit.jsx"));

class Logbooklist extends Component {
  constructor(props) {
    super(props);
    let primeTenant = valiadateTenantPackage();
    this.state = {
      checkboxchecked: false,
      obj: undefined,
      manipulation: 0,
      LogbookNameValidcls: "",
      // LogBookCategoryValidcls: "",
      LogBookcommaValidcls: "",
      LogbookName: "",
      Logbookcomma: "",
      LogBookCategory: "",
      LogbookOldName: "",
      Unitnameclik: "",
      Unitname: "",

      addLogbook: false,
      editLogbook: false,
      retireLogbook: false,

      Columns: [
        {
          header: this.props.t("Logbook.IDS_LBL_FIELDNAMELOG", {
            param: "",
          }),
          datatype: "fieldname",
          rowselector: false,
          visible: true,
          filterable: true,
          className: "clsModulename",
          width: "200px",
        },
      ],
      DynamicColumns: [
        {
          header: this.props.t("Logbook.IDS_LBL_ISMANITERY", {
            param: "",
          }),
          datatype: "isMandatory",
          rowselector: false,
          celltype: "Checkboxinventory",
          visible: true,
          filterable: false,
          isdisabled: true,
          className: "clsModulename",
          width: "200px",
        },
        {
          header: this.props.t("Logbook.IDS_LBL_FIELDNAMELOG", {
            param: "",
          }),
          datatype: "fieldname",
          rowselector: false,
          visible: true,
          isdisabled: true,
          filterable: true,
          className: "clsModulename",
          width: "200px",
        },
        // {
        //   header: this.props.t("Logbook.IDS_LBL_CONTROLTYPE", {
        //     param: "",
        //   }),
        //   datatype: "controltype",
        //   rowselector: false,
        //   visible: true,
        //   filterable: true,
        //   className: "clsModulename",
        //   width: "200px",
        // },
        {
          header: this.props.t("Logbook.IDS_LBL_DATATYPE", {
            param: "",
          }),
          datatype: "datatypevalue",
          rowselector: false,
          visible: true,
          filterable: true,
          className: "clsModulename",
          width: "200px",
        },
        {
          header: this.props.t("Logbook.IDS_LBL_EDITLOG", {
            param: "",
          }),
          datatype: "edit",
          rowselector: false,
          celltype: "Button",
          visible: true,
          isdisabled: true,
          filterable: false,
          className: "clsSelect",
          width: "200px",
          onClick: this.Openfield.bind(this),
        },
      ],
      Staticcontrol: [
        {
          fieldname: this.props.t("Logbook.IDS_LBL_INVENTORYID", {
            param: "",
          }),
          value: "",
          manipulationvisible: false,
          gridvisible: true,
          controltype: "textbox",
          controlvalues: [],
        },
        {
          fieldname: this.props.t("Logbook.IDS_LBL_LOGNAME", {
            param: "",
          }),
          value: "",
          manipulationvisible: true,
          gridvisible: true,
          controltype: "textbox",
          controlvalues: [],
        },
        {
          fieldname: this.props.t("Logbook.IDS_LBL_SIGNEDDATE", {
            param: "",
          }),
          value: "",
          manipulationvisible: false,
          gridvisible: true,
          controltype: "textbox",
          controlvalues: [],
        },
        {
          fieldname: this.props.t("Masters.Taskmaster.IDS_LBL_MODIFIEDON", {
            param: "",
          }),
          value: "",
          datatype: "modifiedon",
          manipulationvisible: false,
          gridvisible: true,
          controltype: "textbox",
          controlvalues: [],
        },
        {
          fieldname: this.props.t("Logbook.IDS_LBL_SIGNEDBY", {
            param: "",
          }),
          value: "",
          manipulationvisible: false,
          gridvisible: true,
          controltype: "textbox",
          controlvalues: [],
        },
        {
          fieldname: this.props.t("Masters.Taskmaster.IDS_LBL_MODIFIEDBY", {
            param: "",
          }),
          value: "",
          manipulationvisible: false,
          gridvisible: true,
          controltype: "textbox",
          controlvalues: [],
        },
        {
          fieldname: this.props.t("Logbook.IDS_LBL_STATUS", {
            param: "",
          }),
          value: "",
          manipulationvisible: false,
          gridvisible: true,
          controltype: "textbox",
          controlvalues: [],
        },

        {
          fieldname:
            primeTenant === "3" || isMultitenant === 0
              ? this.props.t("Logbook.IDS_LBL_MATERIALINVENTORY", {
                param: "",
              })
              : this.props.t("Resource Type", {
                param: "",
              }),
          value: "",
          manipulationvisible: false,
          gridvisible: false,
          controltype: "textbox",
          controlvalues: [],
          selected_repositry: [],
          selectedfield: "",
        },
        {
          fieldname:
            primeTenant === "3" || isMultitenant === 0
              ? this.props.t("Logbook.IDS_LBL_MATERIALQUANTITY", {
                param: "",
              })
              : this.props.t("Resource", {
                param: "",
              }),
          value: "",
          manipulationvisible: false,
          gridvisible: false,
          controltype: "textbox",
          controlvalues: [],
        },
        {
          fieldname: this.props.t("Logbook.IDS_LBL_UNIT", {
            param: "",
          }),
          value: "",
          manipulationvisible: false,
          gridvisible: false,
          controltype: "textbox",
          controlvalues: [],
        },
      ],
      Dynamiccontrol: [],
      FieldnameValidcls: "",
      Fieldname: "",
      Editindex: -1,
      Editvalue: undefined,
      Logbooks: [],
      ServiceToUrl: "",
      ServiceMethodType: "POST",
      ServiceHeaderobject: {},
      ServcieonSuccess: undefined,
      ServcieonFailure: undefined,
      Repositryindex: 0,
      EditRepoindex: "-1",
      fieldcount: -1,
      isconsumable: false,
      isdisableconsumable: false,
      isexpiredate: false,
      isdisableexpiredate: false,
      consumefield: undefined,
      isonexpireddatefield: undefined,
      EditLogbook: {},
      Expiereddatecontrols: [],
      Datatypes: [
        // {
        //   key: 0,
        //   value: this.props.t("Logbook.IDS_LBL_STRING", {
        //     param: "",
        //   }),
        // },
        {
          key: 1,
          value: this.props.t("Logbook.IDS_LBL_INTEGER", {
            param: "",
          }),
        },
        {
          key: 2,
          value: this.props.t("Logbook.IDS_LBL_NUMERICD", {
            param: "",
          }),
        },
        {
          key: 3,
          value: this.props.t("Logbook.IDS_LBL_DATE", {
            param: "",
          }),
        },
        {
          key: 4,
          value: this.props.t("Logbook.IDS_LBL_COMBOFIELD", {
            param: "",
          }),
        },
        {
          key: 5,
          value: this.props.t("Orders.Sheetorders.IDS_LBL_ESIGN", {
            param: "",
          }),
        },
        {
          key: 6,
          value: this.props.t("Logbook.IDS_LBL_DATETIME", { param: "", }),
        },
        {
          key: 7,
          value: this.props.t("Logbook.IDS_LBL_HYPERLINK", { param: "", }),
        },
        {
          key: 8,
          value: this.props.t("Logbook.IDS_LBL_CHECKBOX", { param: "", }),
        },
        {
          key: 9,
          value: this.props.t("Logbook.IDS_LBL_RADIOBUTTON", { param: "", }),
        },
        {
          key: 10,
          value: this.props.t("Logbook.IDS_LBL_MULTISELECT", { param: "", }),
        },
      ],
      selecteddatatype: {
        key: 1,
        value: this.props.t("Logbook.IDS_LBL_INTEGER", {
          param: "",
        }),
      },
      Numbercontrols: [],
      LogbookColumns: [
        {
          header: this.props.t("Logbook.IDS_LBL_SELECT", {
            param: "",
          }),
          datatype: "select",
          rowselector: true,
          visible: true,
          filterable: true,
          className: "clsSelect",
          width: "50px",
        },
        {
          header: this.props.t("Logbook.IDS_LBL_LOGBOOKID"),
          datatype: "logbookid",
          rowselector: false,
          visible: true,
          filterable: false,
          isdisabled:true,
          className: "clsModulename",
          width: "140px",
        },
        {
          header: this.props.t("Logbook.IDS_LBL_LOGBOOKNAME"),
          datatype: "logbookname",
          rowselector: false,
          visible: true,
          filterable: false,
          className: "clsModulename",
          width: "140px",
          isdisabled: true,
        },
        {
          header: this.props.t("Logbook.IDS_LBL_LOGBOOKCATEGORY"),
          datatype: "logbookcategory",
          rowselector: false,
          visible: true,
          filterable: false,
          className: "clsModulename",
          width: "140px",
        },

        {
          header: this.props.t("Logbook.IDS_LBL_CREATEDON"),
          datatype: "addedonview",
          rowselector: false,
          visible: true,
          filterable: false,
          className: "clsModulename",
          width: "140px",
        },
        {
          header: this.props.t("Masters.Taskmaster.IDS_LBL_MODIFIEDON", {
            param: "",
          }),
          datatype: "modifiedon",
          rowselector: false,
          visible: true,
          filterable: true,
          className: "clsModulename",
          width: "200px",
          isdisabled: true,
        },
        {
          header: this.props.t("Logbook.IDS_LBL_CREATEDBY"),
          datatype: "addedby",
          rowselector: false,
          visible: true,
          filterable: false,
          className: "clsModulename",
          width: "140px",
        },
        {
          header: this.props.t("Masters.Taskmaster.IDS_LBL_MODIFIEDBY", {
            param: "",
          }),
          datatype: "modifiedby",
          rowselector: false,
          visible: true,
          filterable: true,
          className: "clsModulename",
          width: "200px",
        },
        {
          header: this.props.t("Logbook.IDS_LBL_STATUS"),
          datatype: "retirestatusview",
          rowselector: false,
          visible: true,
          filterable: false,
          className: "clsModulename",
          width: "140px",
          isdisabled: true,
        },
        {
          header: this.props.t(
            "Audittrail.Audittrailhistory.IDS_LBL_REVIEWEDSTATUS",
            {
              param: "",
            }
          ),
          datatype: "reviewstatusview",
          rowselector: false,
          visible: true,
          filterable: true,
          className: "clsReviewStatus",
          width: "200px",
        },
        {
          header: this.props.t(
            this.props.t("Logbook.IDS_LBL_REVIEWEDBY"),
            {
              param: "",
            }
          ),
          datatype: "msgshow",
          rowselector: false,
          visible: true,
          filterable: true,
          className: "clsModulename",
          width: "200px",
        },

        {
          header: this.props.t(
            this.props.t("Setup.SequenceGenerator.IDS_LBL_ACTIONS"),
            {
              param: "",
            }
          ),
          datatype: "open",
          rowselector: false,
          celltype: "Button",
          visible: true,
          filterable: false,
          className: "clsSelect",
          width: "200px",
          onClick: this.Openlogbook.bind(this),
        },
      ],
      selectedlogbook: null,
      commentopen: false,
      comment: "",
      objsilentaudit: undefined,
      aReview: false,
      reviewstatus: "",
      Optionview: false,
      selectedOption: [],
      tempselecteddata: "",
      SiteMasterValInitLoad: [],
      DefaultSite: {
        istatus: 1,
        sitecode: 0,
        sitename: this.props.t("Setup.Usermaster.IDS_LBL_ALL", {
          param: "",
        }),
        sitestatus: this.props.t("Setup.Usermaster.IDS_LBL_ACTIVE"),
        status: 1,
      },
      logbookbuttondisable: false,
      logbookbuttondisableReview: false,
      logbookbuttondisableretire: false,
      RadioButtonType: 1,
      Material: [{
        key: 0,
        value: this.props.t("Masters.Inventory.IDS_LBL_MATERIAL", { param: "", }),
      }, {
        key: 1,
        value: this.props.t("Masters.Projectmaster.IDS_LBL_PROJECTMASTER", { param: "", }),
      }, {
        key: 2,
        value: this.props.t("Masters.Taskmaster.IDS_LBL_TESTMASTER", { param: "", }),
      }, {
        key: 3,
        value: this.props.t("Setup.Userrights.IDS_LBL_USERMASTER", { param: "", }),
      }],
      ComboboxType: {},
    };
    this.optionKeys = [4, 8, 9, 10];
    this.Activitiesvidget_Lastopen = React.createRef({});
    this.ELNurl = window.appUrl.ELN;
  }

  componentDidMount() {
    document.title = this.props.t("ELNTitle.IDS_LBL_LOGBOOK");
    if (this.props.Logbookopen_Globalsearch?.Open_Type === "Globl_Search_Folder") {
      this.setState({ selectedlogbook: this.props.Logbookopen_Globalsearch }, () => {
        if (this.Activitiesvidget_Lastopen?.current?.length > 0) {
          this.Activitiesvidget_Lastopen.current.push(this.props.Logbookopen_Globalsearch);
        } else {
          this.Activitiesvidget_Lastopen.current = [];
          this.Activitiesvidget_Lastopen.current.push(this.props.Logbookopen_Globalsearch);
        }
        this.Ongetlogbookint();
        this.props.Onresetglobalsearch();
      });
    } else if (this.props.Logbookopen_Globalsearch?.Open_Type === "Activities") {
      this.Ongetlogbookint();
      // this.props.Onresetglobalsearch();
    } else {
      this.Ongetlogbookint();
    }
  }

  Ongetlogbookint = () => {
    let passObjDet = {};
    Servicecalls(
      "" + this.ELNurl + "/Login/LoadSite",
      passObjDet,
      (response) => {
        const newData = response.slice(0);
        newData.splice(response, 0, this.state.DefaultSite);

        this.setState({
          SiteMasterValInitLoad: newData.filter((obj) => {
            if (obj.sitename === "Default") {
              obj.sitename = this.props.t("Setup.Usermaster.IDS_LBL_DEFAULT", {
                param: "",
              });
            }
            return obj;
          }),
          SiteMasterVal: response.filter((obj) => {
            if (obj.sitename === "Default") {
              obj.sitename = this.props.t("Setup.Usermaster.IDS_LBL_DEFAULT", {
                param: "",
              });
            }
            return obj;
          }),

          UserSiteSelected: response !== undefined ? response[0] : {},
        }, () => {
          setTimeout(() => {

            let addlog = ControlRights("IDS_MDL_LOGBOOK", "IDS_TSK_ADDLOGBOOK");
            let editlog = ControlRights("IDS_MDL_LOGBOOK", "IDS_TSK_EDITLOGBOOK");
            let retirelog = ControlRights("IDS_MDL_LOGBOOK", "IDS_TSK_RETIRELOGBOOK");
            let reviewlog = ControlRights("IDS_MDL_LOGBOOK", "IDS_TSK_REVIEWLOGBOOK");

            let aAdd = addlog.UserGroupRights.rights;
            let aEdit = editlog.UserGroupRights.rights;
            let aretire = retirelog.UserGroupRights.rights;
            let areview = reviewlog.UserGroupRights.rights;

            let reviewA = true;
            console.log(this.state.SiteMasterValInitLoad);

            let object = sessionStorage.Username === "Administrator" ? this.state.SiteMasterValInitLoad[0] : { sitecode: $.session.get("Usersite") };
            this.setState({
              addLogbook: aAdd,
              editLogbook: aEdit,
              retireLogbook: aretire,
              reviewLogbook: areview,
              checkboxchecked: false,
              ServiceToUrl: "" + this.ELNurl + "/Master/GetalllogbooksOnSite",
              ServiceHeaderobject: object,
              ServiceMethodType: "POST",
              ServcieonSuccess: this.onGetLogSuccess.bind(this),
              ServcieonFailure: this.onGetUseronsiteFailure.bind(this),
              ServcieProcessbar: false,
              aReview: reviewA,
            });
          }, 500);
        });
      },
      (res) => { }
    );
  }


  onGetLogSuccess(response) {
    let logbooks = response;
    logbooks.map((obj) => {
      if (obj.addedon !== undefined) {
        obj.addedonorg = obj.addedon
        obj.revieweddateorg = obj.revieweddate
        obj.reviewstatusview = obj.reviewstatus;
        let createdate = new Date(obj.addedon);
        obj.addedonview = setDateAsuserDefined(
          convertUTCDateToLocalDate(new Date(createdate)),
          $.session.get("userDefinedDate")
        );
        if (obj.modifieddate !== null && obj.modifieddate !== undefined) {
          let modifieddate = new Date(obj.modifieddate);
          obj["modifiedon"] = setDateAsuserDefined(
            convertUTCDateToLocalDate(new Date(modifieddate)),
            $.session.get("userDefinedDate")
          );
        }
      }

      if (obj.reviewedby !== undefined && obj.revieweddate !== undefined) {
        obj.revieweddate = setDateAsuserDefined(
          convertUTCDateToLocalDate(new Date(new Date(obj.revieweddate))),
          $.session.get("userDefinedDate")
        );
        if (obj.reviewedby === "" && obj.revieweddate === undefined) {
          obj.msgshow = obj.msgshow
        } else {
          obj.msgshow = obj.reviewedby + " " + obj.revieweddate
        }

      }
      obj.retirestatusview = obj.userstatus
      obj.reviewstatusview = obj.reviewstatus

      return obj;
    });
    if (this.props.Logbookopen_Globalsearch?.Open_Type === "Activities") {
      let opendlogbook = response.find(items => items.logbookcode === this.props.Logbookopen_Globalsearch.logbookcode);
      this.setState({ selectedlogbook: opendlogbook }, () => {
        this.props.Onresetglobalsearch();
        this.setState({ Logbooks: logbooks.reverse() });
      });
    } else {
      this.setState({ Logbooks: logbooks.reverse() });
    }



  }

  onGetLogFailure(response) { }

  componentWillUnmount() {
    let Activity;
    if (this.Activitiesvidget_Lastopen && this.Activitiesvidget_Lastopen.current && this.Activitiesvidget_Lastopen.current.length > 0) {
      Activity = this.Activitiesvidget_Lastopen.current[this.Activitiesvidget_Lastopen.current.length - 1];
      let lsActiveWidgets = {
        screenname: "Logbook",
        activityType: "Open",
        userId: sessionStorage.User,
        activewidgetsdetailscode: Activity?.logbookcode || "",
        Activewidgetsdetails: Activity?.logbookid || "",
        sitecode: sessionStorage.Usersite
      };
      Onsaveactivewidgetsdata(lsActiveWidgets);
    }

  }

  UNSAFE_componentWillReceiveProps(nextProps) {

    if (nextProps.Logbookopen_Globalsearch?.Issamp_Page) {
      this.setState({ selectedlogbook: nextProps.Logbookopen_Globalsearch }, () => {
        nextProps.Onresetglobalsearch();
      });
    }

  }

  onAddLogbook = (e) => {


    this.setState({
      manipulation: 1,
      EditRepoindex: "-1",
      fieldcount: -1,
      isconsumable: false,
      isexpiredate: false,
      isdisableconsumable: true,
      isdisableexpiredate: true,
    });

  };


  UsersiteNameInitLoad(id, value, text, object) {
    console.log(object)
    console.log(value)
    console.log(text)
    if (this.ELNurl !== "") {
      this.setState({
        ServiceToUrl: "" + this.ELNurl + "/Master/GetalllogbooksOnSite",
        ServiceHeaderobject: object,
        ServiceMethodType: "POST",
        ServcieonSuccess: this.onGetUseronsiteSuccess.bind(this),
        ServcieonFailure: this.onGetUseronsiteFailure.bind(this),
        ServcieProcessbar: false,
      });
    }


  }
  onGetUseronsiteSuccess(res) {
    // let logbooks = res;
    this.onGetLogSuccess(res)
    // logbooks.map((obj) => {
    //   if (obj.addedon !== undefined) {
    //     let createdate = new Date(obj.addedon);
    //     obj.addedonview = setDateAsuserDefined(
    //       convertUTCDateToLocalDate(new Date(createdate)),
    //       $.session.get("userDefinedDate")
    //     );
    //   }
    //   return obj;
    // })
    this.setState({ Logbooks: this.state.Logbooks })
  }
  onGetUseronsiteFailure(res) {

  }
  onAuditValidateError(res) { }

  onAuditValidateFailure(res) { }

  onEditLogbook = (e) => {
    let lstrepositories = this.state.Logbooks;
    let lsteditrecord = this.state.Records;
    if (lsteditrecord === undefined || lsteditrecord === null) {
      this.props.alert.error(this.props.t("Logbook.IDS_MSG_SELECTRECORD"));
    } else if (lsteditrecord.length !== 1) {
      this.props.alert.error(this.props.t("Logbook.IDS_MSG_SELECTRECORDEDIT"));
    } else if (lsteditrecord[0].userstatus !== this.props.t("Setup.Usermaster.IDS_LBL_ACTIVE")) {
      this.props.alert.error(
        this.props.t("please select active logbook to edit")
      );
    } else {
      if (
        lstrepositories !== undefined &&
        lstrepositories !== null &&
        lstrepositories.length > 0 &&
        lstrepositories.length > this.state.Repositryindex
      ) {
        let reposiory = lstrepositories[this.state.Repositryindex];
        if (reposiory.retirestatus !== -1) {
          let repositroyfields = JSON.parse(reposiory.logbookfields);
          let dynamicfields = repositroyfields.dynamicfields.map(
            this.retrivevaluefromarray.bind(this)
          );
          let numberfields = dynamicfields.filter(
            (d) => d.datatype === 1 || d.datatype === 2
          );
          let datefield = dynamicfields.filter(
            (d) => d.datatype === 3 || d.datatype === 4
          );
          this.setState({
            Editindex: -1,
            obj: reposiory,
            manipulation: 1,
            Dynamiccontrol: dynamicfields,
            LogbookName: reposiory.logbookname,
            LogBookCategory: reposiory.logbookcategory,
            LogbookOldName: reposiory.logbookname,
            fieldcount: reposiory.fieldcount,
            EditRepoindex: this.state.Repositryindex,
            Numbercontrols: numberfields,
            isdisableconsumable:
              numberfields !== null &&
                numberfields !== undefined &&
                numberfields.length > 0
                ? false
                : true,
            isconsumable: reposiory.isconsumable,
            consumefield:
              reposiory.consumefield !== undefined &&
                reposiory.consumefield !== null &&
                numberfields !== null &&
                numberfields !== undefined &&
                numberfields.length > 0
                ? numberfields.find(
                  (a) => a.fieldkey === reposiory.consumefield
                )
                : undefined,
            isonexpireddatefield:
              reposiory.isonexpireddatefield !== undefined &&
                reposiory.isonexpireddatefield !== null &&
                datefield !== null &&
                datefield !== undefined &&
                datefield.length > 0
                ? datefield.find(
                  (a) => a.fieldkey === reposiory.isonexpireddatefield
                )
                : undefined,
            EditLogbook: reposiory,
            isdisableexpiredate:
              datefield !== null &&
                datefield !== undefined &&
                datefield.length > 0
                ? false
                : true,
            isexpiredate: reposiory.isexpiredate,
            Expiereddatecontrols: datefield,
            Unitname: reposiory.unit !== undefined ? reposiory.unit : "",
          });
        } else {
          this.props.alert.error(this.props.t("Logbook.IDS_MSG_RECORDACTIVE"));
        }
      }
    }
  };

  onRetireLogbook = (e) => {
    let lstselected = this.state.Records;
    if (
      lstselected === undefined ||
      lstselected === null ||
      lstselected.length === 0
    ) {
      this.props.alert.error(
        this.props.t("Logbook.IDS_MSG_RECORDRETIRESELECT")
      );
    } else {

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="react-confirm-alert-body">
              <h1>
                {this.props.t("Setup.Usermaster.IDS_LBL_CONFIRM", {
                  param: "",
                })}
              </h1>
              <h6>
                {this.props.t("Logbook.IDS_LBL_DOUWANTORETIRE", {
                  param: "",

                })}{" "}
                {this.state.Records[0].logbookname}?
              </h6>
              <p>
                {" "}
                {this.props.t("Setup.Usermaster.IDS_LBL_NOTE", {
                  param: "",
                })}{" "}
                :
                {this.props.t("Setup.Usermaster.IDS_LBL_NOTECONTENT", {
                  param: "",
                })}{" "}
              </p>
              <div className="react-confirm-alert-button-group">
                <button
                  id="id-logbook-retireclick"
                  onClick={() => {
                    lstselected.filter((obj) => {
                      let createdate

                      if (obj.addedonorg !== undefined && obj.addedonorg !== null && (sessionStorage.userDefinedDate === "dd-MM-yyyy HH:mm:ss" ||
                        sessionStorage.userDefinedDate === "dd-MM-yy HH:mm:ss")) {
                        createdate = obj.addedonorg;
                      } else if (sessionStorage.userDefinedDate !== "UTC Format") {
                        createdate = convertUTCDateToLocalDate(
                          new Date(obj.addedon)
                        );

                      }
                      else {

                        createdate = obj.addedonorg

                      }
                      let rdate
                      if (obj.revieweddateorg !== undefined && obj.revieweddateorg !== null && (sessionStorage.userDefinedDate === "dd-MM-yyyy HH:mm:ss" ||
                        sessionStorage.userDefinedDate === "dd-MM-yy HH:mm:ss")) {
                        rdate = obj.revieweddateorg;
                      } else
                        rdate = obj.revieweddateorg

                      obj.addedon = createdate
                      obj.addedby = $.session.get("Username") === "Administrator" ? obj.addedby : $.session.get("Username");
                      obj.usercode = $.session.get("User") === "Administrator" ? obj.usercode : $.session.get("User");
                      obj.sitecode = $.session.get("Username") === "Administrator" ? obj.sitecode : $.session.get("Usersite");
                      obj.userstatus = this.props.t("Templates.Protocol.IDS_LBL_RETIRED");
                      obj.retirestatus = -1;
                      obj.objmanualaudit = Manualauditobject("retire", "LogBook");
                      obj.reviewedby = obj.reviewedby
                      obj.revieweddate = obj.revieweddateorg !== undefined && obj.revieweddateorg !== null && (sessionStorage.userDefinedDate === "dd-MM-yyyy HH:mm:ss" ||
                        sessionStorage.userDefinedDate === "dd-MM-yy HH:mm:ss") ? obj.revieweddateorg : rdate !== undefined ? rdate : obj.revieweddate
                      obj.msgshow = obj.msgshow;
                      return obj;
                    });
                    let Audit = AuditTrailValidation(
                      "IDS_MDL_LOGBOOK",
                      "IDS_SCN_LOGBOOK",
                      "IDS_TSK_RETIRELOGBOOK"
                    );
                    if (Audit) {
                      $("#LogbookModel").modal("show");

                      this.setState({
                        AuditUrl: "" + this.ELNurl + "/Master/Retirelogbook",
                        AuditObject: lstselected,
                        AuditPassfunction: this.onRetireLogbookSuccess.bind(this),
                        AuditFailfunction: this.onRetireLogbookFailure.bind(this),
                        AuditCancelfunction: this.onRetireLogbookcancel.bind(this)
                      });
                    } else {
                      Servicecalls(
                        "" + this.ELNurl + "/Master/Retirelogbook",
                        lstselected,
                        this.onRetireLogbookSuccess.bind(this),
                        this.onRetireLogbookFailure.bind(this)
                      );
                    }
                    onClose();
                  }}
                >
                  {this.props.t("Setup.Usermaster.IDS_LBL_YES", {
                    param: "",
                  })}
                </button>
                <button id="id-logbook-close" onClick={onClose}>
                  {this.props.t("Setup.Usermaster.IDS_LBL_NO", {
                    param: "",
                  })}
                </button>
              </div>
            </div>
          );
        },
      });



    }
  };
  reviewauditcancel() {
    let record = this.state.Records;
    record.filter((item) => {
      item.addedonview = setDateAsuserDefined(
        convertUTCDateToLocalDate(new Date(item.addedon)),
        $.session.get("userDefinedDate")
      );
      item.msgshow = ""
      item.reviewstatus = ""
      item.reviewstatusview = ""
      return item;
    })

    this.setState({ Records: record });
  }
  onLogBookReview(e) {
    let lstrepositories = this.state.Records;
    if (
      lstrepositories === undefined ||
      lstrepositories === null ||
      lstrepositories.length === 0
    ) {
      this.props.alert.error(
        this.props.t("Logbook.IDS_MSG_SELECTRECORDREVIEW")
      );
    } else {

      let Audit = true;
      if (Audit) {
        $("#LogbookModel").modal("show");
        lstrepositories = lstrepositories.filter((obj) => {


          let createdate
          if (obj.addedonorg !== undefined && obj.addedonorg !== null && (sessionStorage.userDefinedDate === "dd-MM-yyyy HH:mm:ss" || sessionStorage.userDefinedDate === "dd-MM-yy HH:mm:ss")) {
            createdate = obj.addedonorg;
          } else if (sessionStorage.userDefinedDate !== "UTC Format") {
            createdate = new Date(obj.addedon)
            createdate = convertUTCDateToLocalDate(
              new Date(obj.addedon)
            );
          }
          else {
            createdate = obj.addedonorg
          }

          let reviewdbydate = GetutcDate(new Date())



          obj.addedon = createdate;
          obj.addedby = $.session.get("Username") === "Administrator" ? obj.addedby : $.session.get("Username");
          obj.usercode = $.session.get("User") === "Administrator" ? obj.usercode : $.session.get("User");
          obj.sitecode = $.session.get("Username") === "Administrator" ? obj.sitecode : $.session.get("Usersite");
          obj.reviewstatus = "Review";
          obj.retirestatus = obj.retirestatus;
          obj.userstatus = obj.userstatus;
          obj.objmanualaudit = Manualauditobject("Review", "LogBook");
          obj.revieweddate = reviewdbydate;
          obj.reviewedby = sessionStorage.Username;
          obj.msgshow = "";
          return obj;
        });
        this.setState({
          AuditUrl: "" + this.ELNurl + "/Master/Reviewlogbook",
          AuditObject: lstrepositories,
          AuditPassfunction: this.onLogBookReviewSuccess.bind(this),
          AuditFailfunction: this.onLogBookReviewFailure.bind(this),
          AuditCancelfunction: this.reviewauditcancel.bind(this),
        });
      } else {
        Servicecalls(
          "" + this.ELNurl + "/Master/Reviewlogbook",
          lstrepositories,
          this.onLogBookReviewSuccess.bind(this),
          this.onLogBookReviewFailure.bind(this)
        );
      }
    }
  }

  onAuditTrailSaveSuccess(response) {
    if (
      response.bIsSessionKill !== undefined &&
      response.bIsSessionKill === true
    ) {
      killSessionLogout();
      this.setState({
        redirect: true,
      });
    } else {
      this.props.alert.success(
        this.props.t("Logbook.IDS_MSG_REVIEWSUCCES", {
          param: "",
        })
      );
      this.setState({
        auditcomment: false,
        ReviewHistoryRecord: this.state.Records,
      });
      let cfrpassobj = {
        user: this.state.Usercode,
        module: this.state.ModuleCode.name,
        system: this.state.Auditcode,
        fromdate: this.state.AuditHistoryDateFrom,
        todate: this.state.AuditHistoryDateTo,
        sitecode:
          sessionStorage.Username.trim() !== "Administrator"
            ? Number(sessionStorage.Usersite)
            : this.state.UserSiteSelected.sitecode,
      };

      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/GetCFRTransactions",
        cfrpassobj,
        this.onGetCFRTransactions.bind(this),
        this.onAuditValidateFailure.bind(this)
      );

      if (response[0].objsilentaudit !== null) {
        let passObjDet = { objsilentaudit: response[0].objsilentaudit };

        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    }
  }

  onAuditTrailSaveFaliure(response) {
    this.setState({
      auditcomment: false,
    });
  }
  retrivevaluefromarray(d) {
    let datatype = this.state.Datatypes.find((a) => a.key === d.datatype);
    d.datatypevalue = datatype !== undefined ? datatype.value : "String";
    if (datatype === undefined) {
      d.datatype = 0;
    }
    if (d.isMandatory === undefined) {
      d.isMandatory = false;
    }
    return d;
  }

  closeaddcommalogbook = (e) => {
    this.setState({
      LogBookcommaValidcls: "",
      Logbookcomma: "",
      Optionview: false,
    });
  };

  closeaddinventory = (e) => {
    this.setState({
      manipulation: 0,
      LogbookName: "",
      LogBookCategory: "",
      Dynamiccontrol: [],
      Numbercontrols: [],
      Expiereddatecontrols: [],
      isconsumable: false,
      isdisableconsumable: true,
      Fieldname: "",
      checkboxchecked: false,
      Unitname: "",
      Editindex: -1,
      Editvalue: undefined,
      LogbookNameValidcls: "",
      LogBookcommaValidcls: "",
      Logbookcomma: "",
      selecteddatatype: []
    });
  };

  onLogbookNamechange = (value) => {
    this.setState({ LogbookName: value });
  };

  onLogbookcommachange = (value) => {
    this.setState({ Logbookcomma: value });
  };
  onLogbookCategorychange = (value) => {
    this.setState({ LogBookCategory: value });
  };

  unitnamchange = (value) => {
    this.setState({ Unitname: value });
  };
  fieldSelected = (Recordsel, PrimaryRecordsel) => { };

  fieldClicked = (Recordsel) => { };

  dynamicfieldSelected = (Recordsel, PrimaryRecordsel) => { };

  onRightsCheckclick(ColumnDataType, value, Primarykey, object) {
    let Dynamiccontrolobj = this.state.Dynamiccontrol.map((item) => {
      if (item.fieldkey === object.fieldkey) {
        item.isMandatory = value;
      }
      return item;
    });
    this.setState({ Dynamiccontrol: Dynamiccontrolobj });

  }

  dynamicfieldClicked = (Recordsel) => { };

  Openfield = (Recordsel) => {

    let Editindex = this.state.Dynamiccontrol.findIndex(
      (obj) => obj.fieldname === Recordsel.fieldname
    );
    let cvalue;
    this.state.Dynamiccontrol.filter(
      (obj) => obj.fieldkey === Recordsel.fieldkey ?
        cvalue = obj.combovalue : ""

    );
    if (Recordsel.datatypevalue === "Combo box" || Recordsel.datatype === 8 || Recordsel.datatype === 9 || Recordsel.datatype === 10 || Recordsel.datatype === 4) {
      this.setState({
        canusemaster: Recordsel.datatype === 10 || Recordsel.datatype === 4 ? true : false,
        RadioButtonType: Recordsel?.ComboboxType !== undefined ? 2 : 1,
        Optionview: true,
        ComboboxType: Recordsel?.ComboboxType !== undefined ? cvalue : undefined,
        Logbookcomma: cvalue,
        combovalue: cvalue,
        Editindex: Editindex,
        Editvalue: Recordsel,
        Fieldname: Recordsel.fieldname,
        checkboxchecked: false,
        selecteddatatype: this.state.Datatypes.find(
          (a) => a.key === Recordsel.datatype
        ),
      });
    } else {
      this.setState({
        Editindex: Editindex,
        Editvalue: Recordsel,
        Fieldname: Recordsel.fieldname,
        checkboxchecked: false,
        selecteddatatype: this.state.Datatypes.find(
          (a) => a.key === Recordsel.datatype
        ),
      });
    }



  };

  onFieldnamechange = (value) => {
    this.setState({ Fieldname: value, checkboxchecked: true });
  };

  onDatatypeChange = (key, value, text, object) => {
    var keyvalue = parseInt(value);
    var canusemaster = false;
    var obj = this.state.Datatypes.filter((item) => item.key === keyvalue);
    if (obj[0].key === 4 || obj[0].key === 8 || obj[0].key === 9 || obj[0].key === 10) {
      this.setState({ Optionview: true });
      if (obj[0].key === 10 || obj[0].key === 4) {
        canusemaster = true;
      }
      this.setState({ RadioButtonType: 1, ComboboxType: {}, Logbookcomma: "" });
    }
    this.setState({ selecteddatatype: obj[0], canusemaster: canusemaster, Logbookcomma: "" });
  };

  onFieldaddClick = (e) => {

    let {
      selecteddatatype, Logbookcomma
    } = this.state;

    let objsilentaudit = onAuditHandler(
      "insert",
      "LogBook",
      this.props.t("Logbook.IDS_AUDIT_ADDLOGBOOKDYFIELD", {
        user: $.session.get("Username"),
        user1: this.state.Fieldname,
      })
    );

    if (objsilentaudit !== null) {
      let passObjDet = { objsilentaudit: objsilentaudit };

      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        this.onAuditValidateError.bind(this),
        this.onAuditValidateFailure.bind(this)
      );
    }
    let Valide_Flow = true;
    if (selecteddatatype && selecteddatatype.key && (selecteddatatype.key === 4 || selecteddatatype.key === 8
      || selecteddatatype.key === 9 || selecteddatatype.key === 10)) {
      if (Logbookcomma === "") {
        Valide_Flow = false;
        this.setState({ Optionview: true });
      }
    }
    if (
      this.state.Fieldname !== undefined &&
      this.state.Fieldname.trim() !== "" && Valide_Flow
    ) {
      let Editindex = this.state.Dynamiccontrol.findIndex(
        (obj) => obj.fieldname === this.state.Fieldname
      );

      if (Editindex > -1) {
        this.props.alert.error(
          this.props.t("Logbook.IDS_MSG_FIELDEXIST", {
            param: "",
          })
        );
      } else {
        Editindex = this.state.Staticcontrol.findIndex(
          (obj) => obj.fieldname === this.state.Fieldname
        );

        if (Editindex > -1) {
          this.props.alert.error(
            this.props.t("Logbook.IDS_MSG_STATICEXIST", {
              param: "",
            })
          );
        }
      }

      // if(this.optionKeys.includes(selecteddatatype.key) && Logbookcomma === ""){
      //   this.props.alert.error(this.props.t("Inventory.MaterialType.IDS_MSG_COMBONOTE"));
      //   Editindex = 1;
      // }

      if (Editindex <= -1) {
        let Dynamicarray = this.state.Dynamiccontrol;
        let Numberarray = this.state.Numbercontrols;
        let Datearray = this.state.Expiereddatecontrols;
        let fieldcount = this.state.fieldcount + 1;
        let fieldobject = {
          fieldname: this.state.Fieldname,
          fieldkey:
            fieldcount +
            "_" +
            this.state.Fieldname.toLowerCase().replace(/[^a-zA-Z ]/g, ""),
          value: "",
          combovalue: this.state.Logbookcomma,
          manipulationvisible: true,
          gridvisible: true,
          // controltype: this.state.Logbookcomma !== "" ? "dropdown" : "textbox",
          controlvalues: [],
          datatype: this.state.selecteddatatype?.key !== undefined ? this.state.selecteddatatype.key :
            this.state.selecteddatatype !== undefined
              ? this.state.selecteddatatype.length === 0 ? this.state.Datatypes[0].key : this.state.selecteddatatype.key
              : 0,
          datatypevalue:
            this.state.selecteddatatype !== undefined
              ? this.state.selecteddatatype.length === 0 ? this.state.Datatypes[0].value : this.state.selecteddatatype.value
              : "String",
          used: true
        };
        if (this.state.RadioButtonType === 2 && this.state.ComboboxType?.value) {
          fieldobject.ComboboxType = this.state.ComboboxType?.value
        }
        Dynamicarray.push(fieldobject);

        if (fieldobject.datatype === 1 || fieldobject.datatype === 2) {
          Numberarray.push(fieldobject);
        } else if (fieldobject.datatype === 3 || fieldobject.datatype === 4) {
          Datearray.push(fieldobject);
        }
        this.props.alert.success(
          this.props.t("Logbook.IDS_MSG_DYNAMICFIELDADDED", {
            param: "",
          })
        );
        this.setState({
          FieldnameValidcls: "",
          Dynamiccontrol: Dynamicarray,
          Fieldname: "",
          Editindex: -1,
          Editvalue: undefined,
          fieldcount: fieldcount,
          isdisableconsumable:
            Numberarray.length === 0 &&
              this.state.selecteddatatype.value !== "Integer" &&
              this.state.selecteddatatype.value !== "Numeric"
              ? true
              : false,
          consumefield:
            Numberarray.length === 1 ? Numberarray[0] : this.state.consumefield,
          selecteddatatype: this.state.Datatypes[0],
          Numbercontrols: Numberarray,
          Expiereddatecontrols: Datearray,
          isonexpireddatefield:
            Datearray.length === 1
              ? Datearray[0]
              : this.state.isonexpireddatefield,
          isdisableexpiredate:
            Datearray.length === 0 &&
              this.state.selecteddatatype.value !== "Date"
              ? true
              : false,
        });
      }
    } else {
      this.setState({ FieldnameValidcls: "invalid" });
    }
  };

  onFieldupdateClick = (e) => {
    // let {
    //   selecteddatatype, Logbookcomma
    // } = this.state;

    if (
      this.state.Fieldname !== undefined &&
      this.state.Fieldname.trim() !== ""
    ) {
      this.props.alert.success(
        this.props.t("Logbook.IDS_MSG_DYNAMICFIELDEDIT", { param: "" })
      );
      let Editindex = this.state.Dynamiccontrol.findIndex(
        (obj) => obj.fieldname === this.state.Fieldname
      );

      if (Editindex > -1 && Editindex !== this.state.Editindex) {
        this.props.alert.error(
          this.props.t("Logbook.IDS_MSG_FIELDEXIST", {
            param: "",
          })
        );
      } else {
        Editindex = this.state.Staticcontrol.findIndex(
          (obj) => obj.fieldname === this.state.Fieldname
        );

        if (Editindex > -1) {
          this.props.alert.error(
            this.props.t("Logbook.IDS_MSG_STATICEXIST", {
              param: "",
            })
          );
        }
      }
      // if(this.optionKeys.includes(selecteddatatype.key) && Logbookcomma === ""){
      //   this.props.alert.error(this.props.t("Inventory.MaterialType.IDS_MSG_COMBONOTE"));
      //   Editindex = 1;
      // }

      if (Editindex <= -1) {
        let Dynamicarray = this.state.Dynamiccontrol;
        let Numberarray = this.state.Numbercontrols;
        let field = Dynamicarray[this.state.Editindex];
        field.fieldname = this.state.Fieldname;
        field.datatype =
          this.state.selecteddatatype !== undefined
            ? this.state.selecteddatatype.key
            : 0;
        field.datatypevalue =
          this.state.selecteddatatype !== undefined
            ? this.state.selecteddatatype.value
            : "String";
        Dynamicarray[this.state.Editindex] = field;
        Dynamicarray[this.state.Editindex].combovalue = this.state.Logbookcomma

        if (this.state.RadioButtonType === 2 && this.state.ComboboxType?.value) {
          Dynamicarray[this.state.Editindex].ComboboxType = this.state.ComboboxType?.value;
          Dynamicarray[this.state.Editindex].combovalue = this.state.ComboboxType
        }
        if (this.state.RadioButtonType === 1 && this.state.ComboboxType?.value) {
          Dynamicarray[this.state.Editindex].ComboboxType = undefined
        }

        Numberarray = Dynamicarray.filter(
          (item) => item.datatype === 1 || item.datatype === 2
        );

        let EditLogbook =
          this.state.EditLogbook.consumefield === field.fieldkey
            ? field.datatype === 0
              ? false
              : true
            : true;

        let objsilentaudit = onAuditHandler(
          "update",
          "LogBook",
          this.props.t("Logbook.IDS_AUDIT_ADDREPOSITORYDYFIELDUPDATE", {
            user: $.session.get("Username"),
            user1: this.state.Fieldname,
          })
        );

        if (objsilentaudit !== null) {
          let passObjDet = { objsilentaudit: objsilentaudit };

          Servicecalls(
            "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet,
            this.onAuditValidateError.bind(this),
            this.onAuditValidateFailure.bind(this)
          );
        }
        this.setState({
          FieldnameValidcls: "",
          Dynamiccontrol: Dynamicarray,
          Logbookcomma: "",
          Fieldname: "",
          Editindex: -1,
          Editvalue: undefined,
          selecteddatatype: this.state.Datatypes[0],
          Numbercontrols: Numberarray,
          isdisableconsumable:
            this.state.selecteddatatype.value === "String" ? true : false,
          isconsumable: EditLogbook,
        });
      }
    } else {
      this.setState({ FieldnameValidcls: "invalid" });
      this.props.alert.error(this.props.t("Enter Field name", { param: "" }));
    }
  };

  onFieldcancelClick = (e) => {
    let objsilentaudit = onAuditHandler(
      "view",
      "LogBook",
      this.props.t("Common.IDS_ADDREPOSITORYDYFIELDCANCEL", {
        user: $.session.get("Username"),
      })
    );

    if (objsilentaudit !== null) {
      let passObjDet = { objsilentaudit: objsilentaudit };

      Servicecalls(
        "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
        passObjDet,
        this.onAuditValidateError.bind(this),
        this.onAuditValidateFailure.bind(this)
      );
    }
    this.setState({
      Editindex: -1,
      Editvalue: undefined,
      Fieldname: "",
      selecteddatatype: this.state.Datatypes[0],
      Logbookcomma: ""
    });
  };
  onCloseComment() {
    this.setState({ comment: "", commentopen: false });
  }

  onsaveComment(comment) {
    let passObjDetAudit = {};

    passObjDetAudit.objsilentaudit = Silentauditobject(
      "eSign",
      "LogBook",
      this.props.t("Logbook.IDS_AUDIT_LOGAPPROVEESIGNCOMMON", {
        user: store.getState().Loggeduser.username,
        logbookname: this.state.LogbookName.trim(),
      }),
      "",
      "Lslogbooks"
    );
    Servicecalls(
      "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
      passObjDetAudit,
      (res) => { },
      (res) => { }
    );

    this.setState({
      disablesubmit: true,
      comment: comment,
      commentopen: false,
    });
    this.onsavelogbooks();
  }
  onsavelogbooks() {
    if (
      this.state.LogbookName !== undefined &&
      this.state.LogbookName.trim() !== ""
    ) {
      let fields = {
        staticfields: this.state.Staticcontrol,
        dynamicfields: this.state.Dynamiccontrol,
      };
      let logoldName = {},
        lognewName = {},
        editvalnew = {},
        editvalold = {};
      logoldName["LOGBOOK"] = this.state.LogOldName;
      lognewName["LOGBOOK"] = this.state.LogbookName.trim();
      // repnewName["REPOSITORY"] = this.state.LogBookCategory;
      if (this.state.EditRepoindex !== "-1") {
        let repositroyfields = JSON.parse(this.state.obj.logbookfields);
        let oldFields = repositroyfields.dynamicfields;

        let newFields = fields.dynamicfields;

        const isSameUser = (oldFields, newFields) =>
          oldFields.value === newFields.value &&
          oldFields.fieldname === newFields.fieldname;

        const onlyInLeft = (left, right, compareFunction) =>
          left.filter(
            (leftValue) =>
              !right.some((rightValue) =>
                compareFunction(leftValue, rightValue)
              )
          );

        const onlyInA = onlyInLeft(oldFields, newFields, isSameUser);
        const onlyInB = onlyInLeft(newFields, oldFields, isSameUser);

        let index = onlyInB.findIndex(
          (ind) => ind.fieldname === onlyInB[0].fieldname
        );
        if (index > -1) {
          if (onlyInA[0] !== undefined) {
            logoldName["FIELDNAME"] = onlyInA[0].fieldname;
            lognewName["FIELDNAME"] = onlyInB[index].fieldname;
          } else {
            lognewName["FIELDNAME"] = onlyInB[index].fieldname;
          }
        }

        editvalold["field"] = logoldName;
        editvalnew["field"] = lognewName;
      }

      let logbook = {
        addedby: $.session.get("Username") === "Administrator" && this.state.Logbooks[this.state.EditRepoindex] !== undefined ? this.state.Logbooks[this.state.EditRepoindex].addedby : $.session.get("Username"),
        // addedon: GetutcDate(new Date()),
        usercode: $.session.get("User") === "Administrator" && this.state.Logbooks[this.state.EditRepoindex] !== undefined ? this.state.Logbooks[this.state.EditRepoindex].usercode : $.session.get("User"),
        sitecode: $.session.get("Username") === "Administrator" && this.state.Logbooks[this.state.EditRepoindex] !== undefined ? this.state.Logbooks[this.state.EditRepoindex].sitecode : $.session.get("Usersite"),
        logbookname: this.state.LogbookName.trim(),
        logbookcategory: this.state.LogBookCategory,
        logbookfields: JSON.stringify(fields),
        logbookcode:
          this.state.EditRepoindex === "-1"
            ? null
            : this.state.Logbooks[this.state.EditRepoindex].logbookcode,
        fieldcount: this.state.fieldcount,
        isconsumable: this.state.isconsumable,
        consumefield:
          this.state.isconsumable && this.state.consumefield !== undefined
            ? this.state.consumefield.fieldkey
            : "",
        isexpiredate: this.state.isexpiredate,
        isonexpireddatefield:
          this.state.isexpiredate &&
            this.state.isonexpireddatefield !== undefined
            ? this.state.isonexpireddatefield.fieldkey
            : "",
        unit: this.state.Unitname,
        userstatus: this.props.t("Setup.Usermaster.IDS_LBL_ACTIVE"),
        retirestatus: 1,
        reviewedby: this.state.obj !== undefined && this.state.obj.reviewstatus !== "" ? sessionStorage.Username : "",
        reviewstatus: this.state.obj !== undefined && this.state.obj.reviewstatus !== "" ? "Review" : "",
        revieweddate: this.state.obj !== undefined && this.state.obj.reviewstatus !== "" &&
          this.state.obj.revieweddateorg !== undefined ? this.state.obj.revieweddateorg : GetutcDate(new Date()),
        msgshow: this.state.obj !== undefined && this.state.obj.reviewstatus !== "" ? this.state.obj.msgshow : ""
      };
      if (this.state.EditRepoindex === "-1") {
        logbook.reviewedby = "";
        logbook.reviewstatus = "";
        logbook.msgshow = "";
        logbook.addedon = GetutcDate(new Date());
      } else {
        logbook.addedon = new Date(this.state.obj.addedon).toUTCString();
        logbook.modifieddate = GetutcDate(new Date());
      }

      if (this.state.EditRepoindex !== "-1") {
        // logbook["modifieddate"] = convertUTCDateToLocalDate(new Date());
        logbook["modifiedby"] = sessionStorage.Username;
      }
      let Audit = AuditTrailValidation("IDS_MDL_LOGBOOK", "IDS_SCN_LOGBOOK",
        this.state.EditRepoindex === "-1" ? "IDS_TSK_ADDLOGBOOK" : "IDS_TSK_EDITLOGBOOK"
      );
      if (Audit) {
        if (this.state.EditRepoindex === "-1") {
          logbook.objmanualaudit = Manualauditobject("insert", "LogBook", {
            LogbookName: this.state.LogbookName.trim(),
          });
        } else {
          logbook.objmanualaudit = Manualauditobject("update", "LogBook", {
            LogbookName: this.state.LogbookName.trim(),
          });
        }

        $("#LogbookModel").modal("show");
        this.setState({
          AuditUrl: "" + this.ELNurl + "/Master/Savelogbook",
          AuditObject: logbook,
          AuditPassfunction: this.onLogbookSuccess.bind(this),
          AuditFailfunction: this.onLogbookFailure.bind(this),
        });
      } else {
        let objsilentaudit;

        let passObjDetAudit = { objsilentaudit: objsilentaudit };
        Servicecalls(
          "" + this.ELNurl + "/Master/Savelogbook",
          logbook,
          this.onLogbookSuccess.bind(this),
          this.onLogbookFailure.bind(this),

          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDetAudit,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      }
    } else {


      this.setState({
        LogbookNameValidcls: "invalid",

      });
    }
  }
  onSaveLogbookcomma = (e) => {
    if (this.state.Logbookcomma !== "") {
      if(validateCommaSeparate(this.state.Logbookcomma, this.props)) {
        this.setState({
          Logbookcomma: this.state.Logbookcomma,
          Optionview: false,

        });
      }
    } else if (this.state.RadioButtonType === 2) {
      if (this.state?.ComboboxType && typeof this.state?.ComboboxType === "object") {
        this.setState({
          Logbookcomma: this.state.ComboboxType,
          Optionview: false,
        });
      } else {
        this.props.alert.error(this.props.t("Logbook.IDS_MSG_SELECTCOMBOTYPE"));
      }
    } else {
      this.props.alert.error(this.props.t("Logbook.IDS_MSG_SELECTCOMBO"));
    }
  };

  onSaveLogbook = (e) => {
    if (this.state.LogbookName !== "") {
      this.setState({

        LogbookNameValidcls: "",

      });
      this.onsavelogbooks();
    } else if (
      this.state.LogbookName === ""
    ) {
      this.setState({
        commentopen: false,
        LogbookNameValidcls: "invalid",

      });
      this.props.alert.error(this.props.t("Enter logbook name"));
    } else if (this.state.LogbookName === "") {
      this.setState({
        commentopen: false,
        LogbookNameValidcls: "invalid",
      });
      this.props.alert.error(this.props.t("Logbook.IDS_MSG_LOGBOOKNAMENEW"));
    }

  };
  onRetireLogbookSuccess(response) {
    let res = response;
    let lstselected = this.state.Records;

    lstselected.forEach((obj) => {
      let logbookcode = obj.logbookcode;
      res.map((resitem) => {
        if (resitem.logbookcode === logbookcode) {
          obj.userstatus = resitem.userstatus;
          obj.retirestatusview = resitem.userstatus;
          let passObjDet = {};
          passObjDet.objsilentaudit = Silentauditobject(
            "retire",
            "LogBook",
            this.props.t("Logbook.IDS_AUDIT_RETIRESUCCESS", {
              user: store.getState().Loggeduser.username,
              logbookname: resitem.logbookname,
            })
          );

          Servicecalls(
            "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet,
            this.onAuditValidateError.bind(this),
            this.onAuditValidateFailure.bind(this)
          );
        }
        return resitem;
      });
      return lstselected;
    });
    lstselected.map((item) => {
      item.addedonview = setDateAsuserDefined(
        convertUTCDateToLocalDate(new Date(item.addedon)),
        $.session.get("userDefinedDate")
      );
      if (item.revieweddate !== undefined && item.reviewedby !== undefined) {
        item.revieweddate = setDateAsuserDefined(
          convertUTCDateToLocalDate(new Date(item.revieweddate)),
          $.session.get("userDefinedDate")
        );
        if (item.reviewedby !== "") {
          item.msgshow = item.reviewedby + " " + item.revieweddate
        } else {
          item.msgshow = ""
        }
        //  item.status = item.userstatus
      }
      return item;
    });

    const updatedLogbook = this.state.Logbooks.map(item => {
      const match = lstselected.find(
        selected => selected.logbookcode === item.logbookcode
      );
      return match ? match : item;
    });

    this.setState({ Records: lstselected, logbookbuttondisable: true, Logbooks: updatedLogbook, logbookbuttondisableretire: true });
    this.props.alert.success(this.props.t("Logbook.IDS_MSG_LOGRETIRE"));
  }
  onRetireLogbookcancel() {
    let record = this.state.Records;
    record.filter((item) => {
      item.addedonview = setDateAsuserDefined(
        convertUTCDateToLocalDate(new Date(item.addedon)),
        $.session.get("userDefinedDate")
      );

      if (item.revieweddate !== undefined) {
        item.revieweddate = setDateAsuserDefined(
          convertUTCDateToLocalDate(new Date(item.revieweddate)),
          $.session.get("userDefinedDate")
        );
        item.msgshow = item.reviewedby + " " + item.revieweddate
      }
      // item.userstatus = item.userstatus === "Retired" ? "Active" : "Retired"
      item.retirestatus = item.retirestatus === -1 ? 1 : -1
      return item;
    })

    this.setState({ Records: record });
  }
  onRetireLogbookFailure(response) { }
  onLogBookReviewSuccess(response) {
    let logbookselect = this.state.Records;
    // let logbookselect = response;
    let res = response;

    logbookselect.forEach((obj) => {
      let logbookcode = obj.logbookcode;
      res.map((resitem) => {
        if (resitem.logbookcode === logbookcode) {
          obj.reviewstatus = resitem.reviewstatus;
          obj.reviewstatusview = resitem.reviewstatus;
          obj.revieweddate = resitem.revieweddate;
          let passObjDet = {};
          passObjDet.objsilentaudit = Silentauditobject(
            "Review",
            "LogBook",
            this.props.t("Logbook.IDS_AUDIT_REVIEWSUCCESS", {
              user: store.getState().Loggeduser.username,
              logbookname: resitem.logbookname,
            })
          );
          Servicecalls(
            "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet,
            this.onAuditValidateError.bind(this),
            this.onAuditValidateFailure.bind(this)
          );
        }
        return resitem;
      });
      return logbookselect;
    });

    logbookselect.map((item) => {
      item.revieweddateorg = item.revieweddate
      item.addedonview = setDateAsuserDefined(
        convertUTCDateToLocalDate(new Date(item.addedon)),
        $.session.get("userDefinedDate")
      );
      item.revieweddate = setDateAsuserDefined(
        convertUTCDateToLocalDate(new Date(item.revieweddate)),
        $.session.get("userDefinedDate")
      );
      item.msgshow = item.reviewedby + " " + item.revieweddate
      return item;
    });
    if (this.state.Logbooks.length > 0 && this.state.Logbooks !== undefined) {
      logbookselect.map((item) => {
        this.state.Logbooks.map((obj) => {
          if (item.logbookcode === obj.logbookcode) {
            obj.reviewstatusview = item.reviewstatusview;
            obj.msgshow = item.reviewedby + " " + item.revieweddate;
          }
          return obj;
        });
        return true;
      });
    }
    this.setState({ Records: logbookselect, Logbooks: this.state.Logbooks, logbookbuttondisableReview: true, });
    this.props.alert.success(this.props.t("Logbook.IDS_MSG_LOGREVIEW"));

  }
  onLogBookReviewFailure(response) { }
  onLogbookSuccess(response) {
    response.retirestatusview = response.userstatus
    response.addedonorg = response.addedon
    response.revieweddateorg = response.revieweddate
    response.reviewstatusview = response.reviewstatus;
    let createdate = new Date(response.addedon);
    response.addedonview = setDateAsuserDefined(
      convertUTCDateToLocalDate(new Date(createdate)),
      $.session.get("userDefinedDate")
    );
    if (response.modifieddate !== null && response.modifieddate !== undefined) {
      let modifieddate = new Date(response.modifieddate);
      response["modifiedon"] = setDateAsuserDefined(
        convertUTCDateToLocalDate(new Date(modifieddate)),
        $.session.get("userDefinedDate")
      );
    }
    let logoldName = {},
      lognewName = {};
    let categoryold = {},
      categorynew = {};
    let passObjDet = {};
    logoldName["LOGBOOK"] = this.state.LogbookOldName;
    lognewName["LOGBOOK"] = this.state.LogbookName.trim();
    categoryold["LOGBOOK"] = this.state.LogBookCategory;
    categorynew["LOGBOOK"] = this.state.EditLogbook.logbookcategory;

    let status =
      response !== undefined &&
        response.objResponse !== undefined &&
        response.objResponse.status !== undefined
        ? response.objResponse.status
        : false;

    let infromation =
      response !== undefined &&
        response.objResponse !== undefined &&
        response.objResponse.infromation !== undefined
        ? response.objResponse.infromation
        : this.props.t("Logbook.IDS_MSG_LOGBOOKEXIST", {
          param: "",
        });


    if (status) {
      let Logbooks = this.state.Logbooks;
      if (this.state.EditRepoindex === "-1") {
        Logbooks.unshift(response);

        this.props.alert.success(
          this.props.t("Logbook.IDS_MSG_LOGBOOKADDED", {
            param: "",
          })
        );
        passObjDet.objsilentaudit = Silentauditobject(
          "insert",
          "LogBook",
          this.props.t("Logbook.IDS_AUDIT_LOGBOOKADD", {
            name: response.logbookname,
            user: store.getState().Loggeduser.username,
          }),

          "lsrepositories"
        );
        Servicecalls(
          "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
          passObjDet,
          this.onAuditValidateError.bind(this),
          this.onAuditValidateFailure.bind(this)
        );
      } else {
        Logbooks[this.state.EditRepoindex] = response;
        // Logbooks.unshift(response);
        this.props.alert.success(
          this.props.t("Logbook.IDS_MSG_ADDLOGBOOKEDIT", {
            param: "",
          })
        );
        if (this.state.LogbookOldName.trim() !== this.state.LogbookName.trim()) {
          passObjDet.objsilentaudit = Silentauditobject(
            "update",
            "LogBook",
            this.props.t("Logbook.IDS_AUDIT_LOGBOOKUPDATE", {
              from: logoldName.LOGBOOK,
              to: lognewName.LOGBOOK,
              user: store.getState().Loggeduser.username,
            }),

            "lsrepositories"
          );
          Servicecalls(
            "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet,
            this.onAuditValidateError.bind(this),
            this.onAuditValidateFailure.bind(this)
          );
        }
        if (this.state.LogBookCategory !== this.state.EditLogbook.logbookcategory) {
          passObjDet.objsilentaudit = Silentauditobject(
            "update",
            "LogBook",
            this.props.t("Logbook.IDS_AUDIT_LOGBOOKUPDATECATEGORY", {
              from: categorynew.LOGBOOK,
              to: categoryold.LOGBOOK,
              user: store.getState().Loggeduser.username,
            }),

            "lsrepositories"
          );
          Servicecalls(
            "" + this.ELNurl + "/AuditTrail/silentandmanualRecordHandler",
            passObjDet,
            this.onAuditValidateError.bind(this),
            this.onAuditValidateFailure.bind(this)
          );
        }

      }
      this.setState({
        Logbooks: Logbooks,
        manipulation: 0,
        LogbookName: "",
        LogBookCategory: "",
        Dynamiccontrol: [],
        LogbookNameValidcls: "",
        // LogBookCategoryValidcls: "",
        Numbercontrols: [],
        consumefield: undefined,
        Fieldname: "",
        Unitname: "",
      });

    } else {
      this.props.alert.error(infromation);
      passObjDet.objsilentaudit = Silentauditobject(
        "warning",
        "LogBook",
        this.props.t("Logbook.IDS_AUDIT_LOGBOOKEXISTS", {
          logbook: response.logbookname,
          user: $.session.get("Username"),
        })
      );

    }

    this.setState({
      isconsumable: false,
      isdisableconsumable: true,
    });

  }

  onLogbookFailure(response) { }

  onConsumableChange = (e) => {
    this.setState({ isconsumable: e });
    if (e && this.state.consumefield === undefined) {
      this.setState({
        consumefield:
          this.state.Numbercontrols.length > 0
            ? this.state.Numbercontrols[0]
            : undefined,
      });
    }
  };
  onexpireddateChange = (e) => {
    this.setState({ isexpiredate: e });
    if (e && this.state.isonexpireddatefield === undefined) {
      this.setState({
        isonexpireddatefield:
          this.state.Expiereddatecontrols.length > 0
            ? this.state.Expiereddatecontrols[0]
            : undefined,
      });
    }
  };

  onConsumefieldChange = (key, value, text, object) => {
    this.setState({ consumefield: object });
  };
  onExpireddatefieldChange = (key, value, text, object) => {
    this.setState({ isonexpireddatefield: object });
  };

  logbookSelected = (e) => {
    if (e !== undefined && e !== null && e.logbookcode !== undefined) {
      let index = this.state.Logbooks.findIndex(
        (obj) => obj.logbookcode === e.logbookcode
      );

      this.setState({ Repositryindex: index });
    }
  };

  AuditManipSelected(Recordsel, PrimaryRecordsel) {
    // let index =this.state.Logbooks
    let index;
    if (Recordsel.length !== 0) {

      Recordsel.filter((x) => x.retirestatus === -1 && x.reviewstatus === "Review" ?
        this.setState({ logbookbuttondisable: true, logbookbuttondisableReview: true, logbookbuttondisableretire: true }) : x.retirestatus === -1 ?
          this.setState({ logbookbuttondisable: true, logbookbuttondisableReview: false, logbookbuttondisableretire: true }) : x.reviewstatus === "Review" ?
            this.setState({ logbookbuttondisable: false, logbookbuttondisableReview: true, logbookbuttondisableretire: false }) :
            this.setState({ logbookbuttondisable: false, logbookbuttondisableReview: false, logbookbuttondisableretire: false }))



    } else {
      this.setState({ logbookbuttondisable: false, logbookbuttondisableReview: false, logbookbuttondisableretire: false })
    }
    if (Recordsel.length > 1) {
      for (let i = 0; i < Recordsel.length; i++) {
        if (Recordsel[i].retirestatus === -1) {
          this.setState({ logbookbuttondisable: true, logbookbuttondisableReview: true, logbookbuttondisableretire: true })
          break
        } else
          if (Recordsel[i].retirestatus === 1 && Recordsel[i].reviewstatus === "") {
            this.setState({ logbookbuttondisable: true, logbookbuttondisableReview: this.state.logbookbuttondisableReview ? true : false, logbookbuttondisableretire: this.state.logbookbuttondisableretire ? true : false })
            // break
          } else
            if (Recordsel[i].retirestatus === 1 && Recordsel[i].reviewstatus === "Review") {
              this.setState({ logbookbuttondisable: true, logbookbuttondisableReview: this.state.logbookbuttondisableReview ? true : true, logbookbuttondisableretire: this.state.logbookbuttondisableretire ? true : false })
              // break
            }
            else if (Recordsel[i].reviewstatus === "Review") {
              this.setState({ logbookbuttondisableReview: false })
            }
            else {
              this.setState({ logbookbuttondisable: true, logbookbuttondisableReview: true })

            }
      }
    }

    Recordsel.forEach((obj) => {
      let logbookcode = obj.logbookcode;
      index = this.state.Logbooks.findIndex(
        (obj) => obj.logbookcode === logbookcode
      );



    });
    this.setState({
      Records: Recordsel,
      PrimaryRecords: PrimaryRecordsel,
      Repositryindex: index,
    });
  }

  Openlogbook = (Recordsel) => {
    this.setState({ selectedlogbook: Recordsel });
    if (this.Activitiesvidget_Lastopen?.current?.length > 0) {
      this.Activitiesvidget_Lastopen.current.push(Recordsel);
    } else {
      this.Activitiesvidget_Lastopen.current = [];
      this.Activitiesvidget_Lastopen.current.push(Recordsel);
    }
  };

  closeLogbook = (e) => {
    this.setState({ selectedlogbook: null });
  };

  MaterialGet = () => {
    this.setState({ RadioButtonType: 2 });
  }

  render() {
    return (
      <div className="sheets-wrapper">
        <Service
          Tourl={this.state.ServiceToUrl}
          MethodType={this.state.ServiceMethodType}
          onSuccess={this.state.ServcieonSuccess}
          onFailure={this.state.ServcieonFailure}
          Headerobject={this.state.ServiceHeaderobject}
          onReseturl={() => {
            this.setState({ ServiceToUrl: "" });
          }}
        ></Service>

        <Suspense fallback={<div></div>}>
          <Audit
            AuditId="LogbookModel"
            AuditUrl={this.state.AuditUrl}
            AuditObject={this.state.AuditObject}
            AuditPassfunction={this.state.AuditPassfunction}
            AuditFailfunction={this.state.AuditFailfunction}
            AuditCancelfunction={this.state.AuditCancelfunction}
            alert={this.props.alert}
          />
        </Suspense>
        <div className="container-fluid px-0">
          <div className="row">
            <div className="col-md-12 no-gutters">
              <div className="card-inner-body bg-white">

                {this.state.selectedlogbook?.Open_Type !== "Globl_Search_Folder" &&
                  this.state.selectedlogbook !== undefined &&
                  this.state.selectedlogbook !== null ? (
                  <Suspense fallback={<div></div>}>
                    <Logbook
                      logbookdata={this.state.selectedlogbook}
                      closeLogbook={this.closeLogbook.bind(this)}
                    />
                  </Suspense>
                ) : (
                  <div>
                    <div className="menu-inline align-items-center logbook logbook-tab" >

                      <ul className="list-inline float-right">
                        {this.state.addLogbook ? (
                          <li className="list-inline-item">
                            <button id="id-logbook-add"
                              className="btn btn-primary-blue"
                              onClick={this.onAddLogbook.bind(this)} >
                              <i
                                className="fa fa-plus mr-1"
                                aria-hidden="true"
                              />
                              {this.props.t("Logbook.IDS_LBL_ADDLOGBOOK")}
                            </button>
                          </li>
                        ) : (
                          false
                        )}
                        {this.state.editLogbook ? (
                          <li className="list-inline-item">
                            <button id="id-logbook-edit"
                              className="btn btn-primary-blue"
                              onClick={this.onEditLogbook.bind(this)}
                              disabled={this.state.logbookbuttondisable}
                            >
                              <i
                                className="fa fa-pen-square mr-1"
                                aria-hidden="true"
                              />

                              {this.props.t("Logbook.IDS_LBL_EDITLOGBOOK", {
                                param: "",
                              })}
                            </button>
                          </li>
                        ) : (
                          false
                        )}
                        {this.state.retireLogbook ? (
                          <li className="list-inline-item">
                            <button id="id-logbook-retire"
                              className="btn btn-primary-blue"
                              onClick={this.onRetireLogbook.bind(this)}
                              disabled={this.state.logbookbuttondisableretire}
                            >
                              <i
                                className="fas fa-user-minus mr-1"
                                aria-hidden="true"
                              ></i>

                              {this.props.t("Logbook.IDS_LBL_RETIRELOGBOOK", {
                                param: "",
                              })}
                            </button>
                          </li>
                        ) : (
                          false
                        )}
                        {this.state.reviewLogbook ? (
                          <li className="list-inline-item">
                            <button id="id-logbook-review"
                              className="btn btn-primary-blue"
                              onClick={this.onLogBookReview.bind(this)}
                              disabled={this.state.logbookbuttondisableReview}
                            >
                              <i
                                className="far fa-file-alt"
                                aria-hidden="true"
                              ></i>
                              {this.props.t("Logbook.IDS_LBL_REVIEW", {
                                param: "",
                              })}
                            </button>
                          </li>
                        ) : (
                          false
                        )}
                      </ul>
                    </div>

                    <div className="eln-tabs logbook_table">
                      <Suspense fallback={<div></div>}>
                        <KendoGridView
                          primaryKey="logbookcode"
                          source={this.state.Logbooks}
                          Columns={this.state.LogbookColumns}
                          DataSearchvisible={false}
                          ClickedRecord={this.logbookSelected.bind(this)}
                          TopPisiton="0px"
                          OpensheetFn={this.Openlogbook.bind(this)}
                          ShowDetailsVisible={false}
                          SelectedRecords={this.AuditManipSelected.bind(this)}
                          SelectedRecordsArray={this.state.Records}
                          SearchWidth={"100%"}
                          height="calc(100vh - 190px)"
                          name="logbooklist_1"
                          showhidesgridname='logbooklist_1'
                          screenName={"logbooklist_1"}
                        />
                      </Suspense>
                    </div>
                  </div>
                )}

                {this.state.Optionview !== false && (

                  <>


                    <Modal
                      isOpen={this.state.Optionview !== false}
                      toggle={this.closeaddinventory.bind(this)}
                      className="smallPopup logbook-popup  screen-centered-scroll"
                    >
                      <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">
                          {this.state.selecteddatatype.key === 8 ? this.props.t("Logbook.IDS_LBL_ENTERCHECKBOX") : this.state.selecteddatatype.key === 9 ?this.props.t("Logbook.IDS_LBL_RADIOBTNVALUE") : this.state.selecteddatatype.key === 10 ? this.props.t("Logbook.IDS_LBL_MULTISELECTDROP") : this.props.t("Logbook.IDS_LBL_ENTERCOMBO")}
                        </h5>
                      </div>

                      <ModalBody>
                        {this.state.canusemaster && <div className="row">
                          <div className="col-md-12">
                            {isMultitenant === 2 || plantype === "2" ? "" :
                              <div className="equal-split-flex w-100 parent-padd-1 pb-0">
                                <div className="form-group">
                                  <label className={"radio"}>
                                    <input
                                      type="radio"
                                      value="1"
                                      name="Selectordershow"
                                      onChange={() => { this.setState({ RadioButtonType: 1, Logbookcomma: typeof this.state.Logbookcomma === "object" ? "" : this.state.Logbookcomma, ComboboxType: undefined }); }}
                                      checked={this.state.RadioButtonType === 1} />
                                    <span>
                                    {this.props.t("Logbook.IDS_LBL_RAW", { param: "", })}
                                    </span>
                                  </label>
                                </div>
                                <div className="form-group">
                                  <label className={"radio"}>
                                    <input
                                      type="radio"
                                      value="2"
                                      name="Selectordershow"
                                      onChange={this.MaterialGet.bind(this)}
                                      checked={this.state.RadioButtonType === 2} />
                                    <span>
                                     {this.props.t("Logbook.IDS_LBL_MASTERS", { param: "", })}
                                    </span>
                                  </label>
                                </div>

                              </div>}
                          </div>
                        </div>}

                        <p className="policyBgClr note-text">
                          {this.props.t("Setup.Passwordpolicy.IDS_LBL_NOTE", { param: "", }) + " : "}
                          {this.state.RadioButtonType === 1 ?
                            this.props.t("Inventory.MaterialType.IDS_MSG_COMBONOTE", { param: "", }) :
                            this.props.t("Inventory.MaterialType.IDS_LBL_MATERIALCOMBO", { param: "", })}
                        </p>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group flex-form-group">
                              {this.state.RadioButtonType === 1 ?
                                <Suspense fallback={<div></div>}>
                                  <TextBox
                                    txtid="id-logbook-commaseparated"
                                    txtType=""
                                    txtClsname={
                                      "form-control " +
                                      this.state.LogBookcommaValidcls
                                    }
                                    txtName="LogbookName"
                                    txtPlaceholder=""
                                    txtDataType="Text"
                                    txtmaxlength="200"
                                    txtvalue={this.state.Logbookcomma}
                                    sendData={this.onLogbookcommachange.bind(this)}
                                    txtrequired="true"
                                    autofocus="true"
                                  />
                                </Suspense> :

                                <Suspense fallback={<div></div>}>
                                  <KendoCombobox
                                    initialValue=""
                                    id="id-combo-sheetorder"
                                    Datasource={this.state.Material}
                                    DefaultValue={this.state.ComboboxType}
                                    onvaluechange={(object) => {
                                      this.setState({ ComboboxType: object });
                                    }}
                                    ValueMember="key"
                                    DisplayMember="value" />
                                </Suspense>}

                            </div>


                          </div>
                        </div>
                      </ModalBody>
                      <div className="modal-footer">
                        <button id="id-logbook-save"
                          className="btn btn-user btn-primary-blue mg-r-1"
                          onClick={this.onSaveLogbookcomma.bind(this)}
                        >
                          <i className="far fa-save mr-1" aria-hidden="true"></i>

                          {this.props.t("Masters.Inventory.IDS_LBL_UPDATE")}
                        </button>
                        <button id="id-logbook-closeaddcommalogbook"
                          type="button"
                          className="textBtn btn_white_bg"
                          onClick={this.closeaddcommalogbook.bind(this)}
                        >
                          {this.props.t("Setup.Usermaster.IDS_LBL_CLOSE")}
                        </button>
                      </div>
                    </Modal>
                  </>
                )}

                {this.state.manipulation !== 0 && (
                  <Modal
                    isOpen={this.state.manipulation !== 0}
                    toggle={this.closeaddinventory.bind(this)}
                    className="largePopup logbook-popup  screen-centered-scroll"
                  >
                    <div className="modal-header">
                      <h5 className="modal-title" id="staticBackdropLabel">
                        {this.state.EditRepoindex === "-1"
                          ? this.props.t("Logbook.IDS_LBL_ADDLOGBOOK")
                          : this.props.t("Logbook.IDS_LBL_EDITLOGBOOK")}
                      </h5>
                    </div>
                    <ModalBody>
                      <div className="row">
                        <div className="col-md-5 mg-b-sm-2">
                          <div className="form-group flex-form-group">
                            <label className="required">
                              {this.props.t("Logbook.IDS_LBL_NAME", {
                                param: "",
                              })}
                            </label>
                            <Suspense fallback={<div></div>}>
                              <TextBox
                                txtid="id-logbook-LogbookName"
                                txtType="text"
                                txtClsname={
                                  "form-control " +
                                  this.state.LogbookNameValidcls
                                }
                                txtName="LogbookName"
                                txtPlaceholder=""
                                txtDataType="Text"
                                txtmaxlength="100"
                                txtvalue={this.state.LogbookName}
                                sendData={this.onLogbookNamechange.bind(this)}
                                txtrequired="true"
                                autofocus="true"
                              />
                            </Suspense>
                          </div>
                          <div className="form-group flex-form-group">
                            <label >
                              {this.props.t("Logbook.IDS_LBL_CATEGORY")}
                            </label>
                            <Suspense fallback={<div></div>}>
                              <TextBox
                                txtid="id-logbook-category"
                                txtType="text"
                                txtClsname={
                                  "form-control "}
                                txtName="LogbookCategory"
                                txtPlaceholder=""
                                txtDataType="Text"
                                txtmaxlength="100"
                                txtvalue={this.state.LogBookCategory}
                                sendData={this.onLogbookCategorychange.bind(
                                  this
                                )}
                                txtrequired="true"
                              // autofocus="true"
                              />
                            </Suspense>
                          </div>

                          <div className="mg-t-2 staticFieldBlock cardBlock">
                            <h6 className="h6">
                              {/* Static fields */}
                              {this.props.t("Logbook.IDS_LBL_STATICFIELDS", {
                                param: "",
                              })}
                            </h6>

                            <Suspense fallback={<div></div>}>
                              <KendoGridView
                                primaryKey="fieldname"
                                source={this.state.Staticcontrol}
                                DateFrom={new Date()}
                                DateTo={new Date()}
                                onDateFromChange={null}
                                onDateToChange={null}
                                Columns={this.state.Columns}
                                DataSearchvisible={true}
                                SelectedRecords={this.fieldSelected.bind(this)}
                                ClickedRecord={this.fieldClicked.bind(this)}
                                Data={this.state.Staticcontrol}
                                TopPisiton="115px"
                                height="calc(100vh - 320px)"
                                ShowDetailsVisible={false}
                                
                              // showhidesgridname='logbooklist_1'
                              />
                            </Suspense>
                          </div>
                        </div>
                        <div className="col-md-7">
                          <div>
                            <h6 className="h6">
                              {/* Dynamic fields */}
                              {this.props.t("Logbook.IDS_LBL_DYNAMICFIELDS", {
                                param: "",
                              })}
                            </h6>
                            <div className="dynamicFieldBlock cardBlock">
                              <div>
                                <div className="login-form sm-full-width-input flex-form-group equal-split-flex">
                                  <div className="form-group mr-2">
                                    <label className="required">
                                      {/* Field name */}
                                       {this.props.t(
                                        "Logbook.IDS_LBL_FIELDNAMELOG",
                                        {
                                          param: "",
                                        }
                                      )}
                                    </label>
                                    <Suspense fallback={<div></div>}>
                                      <TextBox
                                        txtid="id-logbook-fieldname"
                                        txtType="text"
                                        txtClsname={
                                          "form-control " +
                                          this.state.FieldnameValidcls
                                        }
                                        txtName="Username"
                                        txtPlaceholder=""
                                        txtDataType="Text"
                                        txtmaxlength="100"
                                        txtvalue={this.state.Fieldname}
                                        sendData={this.onFieldnamechange.bind(
                                          this
                                        )}
                                        txtrequired="true"
                                        autofocus="true"
                                      />
                                    </Suspense>
                                  </div>
                                  <div className="form-group mr-2">
                                    <label className="required">
                                      {/* Data type */}
                                      {this.props.t(
                                        "Logbook.IDS_LBL_DATATYPE",
                                        {
                                          param: "",
                                        }
                                      )}
                                    </label>
                                    <Suspense fallback={<div></div>}>
                                      <SelectBox
                                        Keyvalue="key"
                                        selClsname={"form-control "}
                                        Datasource={this.state.Datatypes}
                                        ValueMember="key"
                                        DisplayMember="value"
                                        valuechange={this.onDatatypeChange.bind(
                                          this
                                        )}
                                        value={this.state.selecteddatatype}

                                        readOnly={
                                          this.state.Editindex > -1
                                            ? true
                                            : false
                                        }
                                        optiondisabled={"true"}
                                      />
                                    </Suspense>
                                  </div>
                                  <div className="form-group">
                                    {this.state.Editindex > -1 ? (
                                      <div className="d_flex_btn">
                                        <button id="id-logbook-fieldupdate"
                                          type="button"
                                          className="btn btn-user btn-primary-blue"
                                          onClick={this.onFieldupdateClick.bind(
                                            this
                                          )}
                                          disabled={this.state.Logbookcomma !== "" ? undefined :
                                            !this.state.checkboxchecked
                                              ? true
                                              : undefined
                                          }
                                        >
                                          <i className="far fa-check-square"></i>
                                          <span multilingual="submit">
                                            {/* update */}
                                            {this.props.t(
                                              "Logbook.IDS_LBL_UPDATE",
                                              {
                                                param: "",
                                              }
                                            )}
                                          </span>
                                        </button>
                                        <button id="id-logbook-fieldcancel"
                                          type="button"
                                          className="btn btn-user btn-primary-blue"
                                          onClick={this.onFieldcancelClick.bind(
                                            this
                                          )}
                                        >
                                          <i className="far fa-check-square"></i>
                                          <span multilingual="submit">
                                            {/* cancel */}
                                            {this.props.t(
                                              "Logbook.IDS_LBL_CANCEL",
                                              {
                                                param: "",
                                              }
                                            )}
                                          </span>
                                        </button>
                                      </div>
                                    ) : (
                                      <button id="id-logbook-fieldadd"
                                        type="button"
                                        className="btn btn-user btn-primary-blue"
                                        onClick={this.onFieldaddClick.bind(
                                          this
                                        )}
                                        disabled={
                                          this.state.Fieldname.trim() !== ""
                                            ? false
                                            : true
                                        }
                                      >
                                        <i className="far fa-check-square"></i>
                                        <span multilingual="submit">
                                          {/* Add */}
                                          {this.props.t("Logbook.IDS_LBL_ADD", {
                                            param: "",
                                          })}
                                        </span>
                                      </button>
                                    )}
                                  </div>
                                </div>
                                <div className="clear"></div>
                              </div>
                              <Suspense fallback={<div></div>}>
                                <KendoGridView
                                  primaryKey="fieldname"
                                  //showhidesgridname='logbooklist_1'
                                  source={this.state.Dynamiccontrol}
                                  DateFrom={new Date()}
                                  DateTo={new Date()}
                                  onDateFromChange={null}
                                  onDateToChange={null}
                                  Columns={this.state.DynamicColumns}
                                  DataSearchvisible={true}
                                  SelectedRecords={this.dynamicfieldSelected.bind(
                                    this
                                  )}
                                  ClickedRecord={this.dynamicfieldClicked.bind(
                                    this
                                  )}
                                  Oncheckboxchecked={this.onRightsCheckclick.bind(
                                    this
                                  )}
                                  Data={this.state.Dynamiccontrol}
                                  OpensheetFn={this.Openfield.bind(this)}
                                  TopPisiton="115px"
                                  ShowDetailsVisible={false}
                                />
                              </Suspense>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <button id="id-logbook-savelog"
                        className="btn btn-user btn-primary-blue mg-r-1"
                        onClick={this.onSaveLogbook.bind(this)}
                      >
                        <i className="far fa-save mr-1" aria-hidden="true"></i>

                        {this.props.t("Logbook.IDS_LBL_SAVE", {
                          param: "",
                        })}
                      </button>
                      <Comment
                        Isopen={this.state.commentopen}
                        Closecomment={this.onCloseComment.bind(this)}
                        Onsavecomment={this.onsaveComment.bind(this)}
                        ItemEsignDetails={this.state.objsilentaudit}
                        batchid={this.state.LogbookName}
                        module={"LogBook"}
                        moduleName={"LogBook"}
                        actionperform={this.props.t("orderapprovel.IDS_LBL_SAVELOGBOOK")}
                      ></Comment>
                      <button id="id-logbook-closeinventory"
                        type="button"
                        className="textBtn btn_white_bg button"
                        onClick={this.closeaddinventory.bind(this)}
                      >
                        {this.props.t("Logbook.IDS_LBL_CLOSE")}
                      </button>
                    </div>
                  </Modal>
                )}

              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withAlert()(withTranslation(Logbooklist));
